export default "__VITE_ASSET__50f4804e__"